import { useEffect } from "react";

import { redirectToNotFound } from "utils/classroom";

function RedirectToNotFound() {
  useEffect(() => {
    redirectToNotFound();
  }, []);
  return null;
}

export { RedirectToNotFound };
